const LoadingBarComponent = {
    templateUrl: '/ui/loadingBar/loadingBar.tpl.html',
    controller: 'loadingBarController',
    bindings: {
        message: '@'
    }
};

angular.module('umCore')
    .component('loadingBar', LoadingBarComponent);
